import fetch from "node-fetch";
import React from 'react';
import { withRouter } from 'react-router-dom';
import ViewPropertyCard from '../../containers/viewPropertyCard';

class ViewProperty extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            data: [],
        }
    }

    componentDidMount() {
        let URL = `/v1/property/inventory/detail-with-property?uid=${this.props.match.params.id}`;
        fetch(URL)
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                if (result.message !== 'Ok') {
                    //It should be only return
                    console.log(result.message)
                    return;
                }
                this.setState({
                    data: result && result.data,
                    loaded: true,
                });

            });
    }

    render() {
        return (
            <div>
                {this.state.loaded ?
                    <ViewPropertyCard data={this.state.data}/>
                : ''}
            </div>
        );
    }
}

export default withRouter(ViewProperty);


// WEBPACK FOOTER //
// ./src/app/components/view-property/index.js